<template>
    <div>
        <el-card style="margin-top: 20px;margin-bottom: 20px;">
            <div slot="header" class="clearfix">
                <span>反向挂单</span>
                <el-button v-if="dataList.length==0" style="float: right; padding: 3px 0" type="text"
                           @click="openReverserOderDialog">新增
                </el-button>
            </div>
            <el-table class="reverser-order-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column fixed prop="pair" label="交易对" width="150"></el-table-column>
                <el-table-column label="禁用">
                    <template slot-scope="scope">
                        <el-switch active-color="#13ce66" :value="scope.row.status"
                                   @change="updateStatus(scope.row, $event)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="userId" label="用户id" show-overflow-tooltip></el-table-column>
                <el-table-column prop="bidTriggerAmount" label="买单触发量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="askTriggerAmount" label="卖单触发量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="bidPriceCoefficient" label="买单价格系数" show-overflow-tooltip></el-table-column>
                <el-table-column prop="askPriceCoefficient" label="卖单价格系数" show-overflow-tooltip></el-table-column>
                <el-table-column prop="bidAmountCoefficient" label="买单数量系数" show-overflow-tooltip></el-table-column>
                <el-table-column prop="askAmountCoefficient" label="卖单数量系数" show-overflow-tooltip></el-table-column>
                <el-table-column label="创建时间" width="180">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="更新时间" width="180">
                    <template slot-scope="scope">
                        <span>{{scope.row.updateTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" @click="openUpdateReverserOderDialog(scope.row)">
                            修改
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="clearData">
            <div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">交易对</span>
                    <el-input maxlength="60" style="width: 70%" size="small" v-model="reverserOderData.pair"
                              :disabled="true"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">用户id</span>
                    <el-input maxlength="60" style="width: 70%" size="small"
                              v-model="reverserOderData.userId"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">买单触发量</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="reverserOderData.bidTriggerAmount"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">卖单触发量</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="reverserOderData.askTriggerAmount"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">买单价格系数</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="reverserOderData.bidPriceCoefficient"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">卖单价格系数</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="reverserOderData.askPriceCoefficient"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">买单数量系数</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="reverserOderData.bidAmountCoefficient"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">卖单数量系数</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="reverserOderData.askAmountCoefficient"></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="createReverserOder">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: 'ReverserOrder',
        props: {dataList: Array, pair: String},
        data() {
            return {
                loading: false,
                dialogVisible: false,
                dialogTitle: "",
                reverserOderData: { //数据对象
                    pair: "",
                    userId: "",
                    bidTriggerAmount: "",
                    askTriggerAmount: "",
                    bidPriceCoefficient: "",
                    askPriceCoefficient: "",
                    bidAmountCoefficient: "",
                    askAmountCoefficient: "",
                    status: true
                }
            };
        },
        methods: {
            queryReverseOrderConfigList() {
                this.$emit('refreshData');
            },
            updateStatus(row, value) {
                api.updateReverseStatus({id: row.id, status: value}).then(response => {
                    if (response.code == 0) {
                        this.queryReverseOrderConfigList();
                    } else {
                        this.$message.success('操作失败');
                    }
                });
            },
            createReverserOder() {
                if (this.reverserOderData.pair == "") {
                    this.$message.success('请输入交易对!');
                    return
                }
                if (this.reverserOderData.userId == "") {
                    this.$message.success('请输入用户id!');
                    return
                }
                if (this.reverserOderData.bidTriggerAmount == "") {
                    this.$message.success('请输入买单触发量!');
                    return
                }
                if (this.reverserOderData.askTriggerAmount == "") {
                    this.$message.success('请输入卖单触发量!');
                    return
                }
                if (this.reverserOderData.bidPriceCoefficient == "") {
                    this.$message.success('请输入买单价格系数!');
                    return
                }
                if (this.reverserOderData.askPriceCoefficient == "") {
                    this.$message.success('请输入卖单价格系数!');
                    return
                }
                if (this.reverserOderData.bidAmountCoefficient == "") {
                    this.$message.success('请输入买单数量系数!');
                    return
                }
                if (this.reverserOderData.askAmountCoefficient == "") {
                    this.$message.success('请输入卖单数量系数!');
                    return
                }

                this.loading = true;
                api.updateReverseConfig(this.reverserOderData).then(response => {
                    if (response.code == 0) {
                        this.dialogVisible = false;
                        this.$message.success(this.dialogTitle + '成功');
                        this.queryReverseOrderConfigList();
                    } else {
                        this.$message.success(this.dialogTitle + '失败');
                    }
                })
                setTimeout(() => {
                    this.loading = false;
                }, 1000);
            },
            openReverserOderDialog() {
                this.reverserOderData.pair = this.pair;
                this.dialogTitle = "增加";
                this.dialogVisible = true;
            },
            openUpdateReverserOderDialog(row) {
                this.reverserOderData = { //数据对象
                    pair: row.pair,
                    userId: row.userId,
                    bidTriggerAmount: row.bidTriggerAmount,
                    askTriggerAmount: row.askTriggerAmount,
                    bidPriceCoefficient: row.bidPriceCoefficient,
                    askPriceCoefficient: row.askPriceCoefficient,
                    bidAmountCoefficient: row.bidAmountCoefficient,
                    askAmountCoefficient: row.askAmountCoefficient,
                    status: row.status
                }
                this.dialogTitle = "修改";
                this.dialogVisible = true;
            },
            clearData() {
                this.loading = false;
                this.reverserOderData = { //数据对象
                    pair: this.pair,
                    userId: "",
                    bidTriggerAmount: "",
                    askTriggerAmount: "",
                    bidPriceCoefficient: "",
                    askPriceCoefficient: "",
                    bidAmountCoefficient: "",
                    askAmountCoefficient: "",
                    status: true
                }
            }
        },
        created() {
            this.reverserOderData.pair = this.pair;
        }
    };
</script>

<style lang="less" scoped>
    .preview-opration {
    }

    .reverser-order-list {
        border: 1px solid #f2ece2;
        clear: both;
        width: 100%;
        .reverser-order-table {
            margin-top: 30px;
        }
    }
</style>
